import { Checkbox, LinkButton } from '../../../components/ui';
import { formatCount, maskPhoneDisplay, shortenName } from '../../../lib/format';
import { alternarItem } from '../formulario';
import type { SellerOption, SenderOption } from '../types';

/**
 * "Atribuir chats ao time": so as vendedoras de papel COMERCIAL da empresa.
 *
 * Decisoes nao obvias (E5, 25/09/2026):
 *  1. O numero de saida e o do comercial da empresa. Quem responde cai com
 *     as vendedoras e, se ela fechar, vira "fechado por" -- a comissao
 *     continua do Converte Facil, creditada ao ultimo toque. O texto diz
 *     isso aqui, onde a escolha e feita.
 *  2. Nenhuma marcada = RODIZIO entre todas. Marcar e opcional; forcar a
 *     escolha em todo envio seria um passo a mais sem ganho.
 *  3. A menos carregada ganha o selo "menos carregada": e a sugestao, nao a
 *     regra.
 *  4. Sem vendedora comercial, o bloco vira um estado vazio que ensina (o
 *     que acontece com as respostas) e leva ao cadastro.
 */
export function AtribuirAoTime({
  sellers,
  selecionadas,
  onChange,
  companyName,
  companyId,
  sender,
}: {
  readonly sellers: readonly SellerOption[];
  readonly selecionadas: readonly string[];
  readonly onChange: (ids: readonly string[]) => void;
  readonly companyName: string;
  readonly companyId: string;
  readonly sender: SenderOption | null;
}): JSX.Element {
  if (sellers.length === 0) {
    return (
      <div className="flex flex-col gap-2 rounded-xl border border-dashed border-edge bg-elevated px-4 py-4 text-sm">
        <p className="font-medium text-ink">Atribuir chats ao time</p>
        <p className="text-ink-muted">
          {companyName} não tem vendedora com papel comercial. As respostas vão cair no número do comercial sem dono e a venda assistida não terá quem registrar.
        </p>
        <div>
          <LinkButton to={`/admin/empresas/${companyId}`} size="sm" icon="usuarios">
            Cadastrar vendedora
          </LinkButton>
        </div>
      </div>
    );
  }

  const menosCarregada = [...sellers].sort((a, b) => a.openChats - b.openChats)[0] ?? null;
  const nomes = (ids: readonly SellerOption[]): string => ids.map((s) => shortenName(s.name)).join(', ');
  const escolhidas = sellers.filter((s) => selecionadas.includes(s.id));
  const numero = sender === null ? 'número do comercial' : `${maskPhoneDisplay(sender.phoneE164)}, o WhatsApp do comercial de ${companyName}`;

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-1 text-sm font-medium text-ink">Atribuir chats ao time</legend>
      <p className="text-xs text-ink-subtle">
        As respostas chegam no {numero}, e aparecem na tela Comercial com este envio como origem. Quem fechar a venda fica como "fechado por"; a comissão continua creditada
        ao toque.
      </p>
      <div className="grid gap-2 sm:grid-cols-2">
        {sellers.map((s) => (
          <Checkbox
            key={s.id}
            checked={selecionadas.includes(s.id)}
            onChange={() => onChange(alternarItem(selecionadas, s.id))}
            label={shortenName(s.name)}
            description={`${formatCount(s.openChats)} ${s.openChats === 1 ? 'conversa aberta' : 'conversas abertas'} agora${menosCarregada !== null && s.id === menosCarregada.id && sellers.length > 1 ? ' · menos carregada' : ''}`}
          />
        ))}
      </div>
      <p aria-live="polite" className="text-xs text-ink-muted">
        {escolhidas.length === 0 ? `Nenhuma marcada: rodízio entre ${nomes(sellers)}.` : `Só ${nomes(escolhidas)} ${escolhidas.length === 1 ? 'recebe' : 'recebem'} as respostas.`}
      </p>
    </fieldset>
  );
}
